import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { TransferState } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { WrapperService } from '../utils/wrapper-service';

@Injectable({
  providedIn: 'root'
})
export class FinancialBackendService {
  pagedDataAny: any;
  urlSuffixPath=`${environment.serviceApiUrl}/financial-backend`;
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private transferHttp: TransferState, 
    private http: HttpClient) { }

    getStockChartWithVolume(code: string, date: string, fileName: string, fileFormat: string): Observable<string> {
      let postUrl = `${this.urlSuffixPath}/stock/chart?code=` + (code) + "&date=" + date  + "&fileName=" + fileName  + "&fileFormat=" + fileFormat;
      return WrapperService.getData(this.transferHttp,this.platformId,postUrl, code, () => {
        return this.http.post(postUrl, code);
        })
    }
    
    getCoinChartWithVolume(code: string, date: string, fileName: string, fileFormat: string): Observable<string> {
      let postUrl = `${this.urlSuffixPath}/coin/chart?code=` + (code) + "&date=" + date  + "&fileName=" + fileName  + "&fileFormat=" + fileFormat;
      return WrapperService.getData(this.transferHttp,this.platformId,postUrl, code, () => {
        return this.http.post(postUrl, code);
        })
    }
  
}
